import { render, staticRenderFns } from "./Bar.vue?vue&type=template&id=53394759&scoped=true&"
import script from "./Bar.vue?vue&type=script&lang=js&"
export * from "./Bar.vue?vue&type=script&lang=js&"
import style0 from "./Bar.vue?vue&type=style&index=0&id=53394759&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53394759",
  null
  
)

export default component.exports